import { comparisonTableTexts } from './text-content.js';

const tableRow = document.querySelector(".comparing-list__item");
const tableList = document.querySelector(".comparing-list");

for (let i = 1; i < comparisonTableTexts.length; i++) {
  tableList.append(tableRow.cloneNode(true));
}

comparisonTableTexts.forEach((item, index) => {
  tableList.children[index].querySelector('.comparing-item__icon').classList.add(item.icon);
  tableList.children[index].querySelector('.comparing-item__feature').dataset.i18n = item.feature;
  tableList.children[index].querySelector('.comparing-item__explanation').dataset.i18n = item.explanation;
  tableList.children[index].querySelector('.comparing-item__free').classList.add(item.isFreeContains ? "feature-available" : "feature-unavailable");
  tableList.children[index].querySelector('.comparing-item__pro').classList.add(item.isProContains ? "feature-available" : "feature-unavailable");
});
